import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Reset20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.53032 2.03033L5.46966 0.969666L0.939331 5.5L5.46966 10.0303L6.53032 8.96967L3.81066 6.25H12.5C15.3995 6.25 17.75 8.6005 17.75 11.5C17.75 14.3995 15.3995 16.75 12.5 16.75H8V18.25H12.5C16.2279 18.25 19.25 15.2279 19.25 11.5C19.25 7.77208 16.2279 4.75 12.5 4.75H3.81065L6.53032 2.03033Z'
      fill='currentColor'
    />
  </Svg>
);

Reset20.displayName = 'Reset20';
export default Reset20;
